import type { FaireProductEntity } from "../../entity_types/product";

export const p_nenq47vcts: FaireProductEntity = {
  token: "p_nenq47vcts",
  type: "product",
  name: "Long Curly Wavy Hair 16 Clip In Hair Extension",
  brandToken: "b_mjd9qy3dnh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/726df0d4568b221c62c8948a1bd2bb6bad94ca2f9e2b66d1d81e6d639314d438.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce848f85c6258af195aab85fe565f9848d31f6cc3ee00cd77d300ab97973fcf2.jpeg",
    "https://cdn.faire.com/fastly/b3660963335149ea8634948916bb79b1b808f27b2fdbdd4cb2781592ba338cd5.jpeg",
    "https://cdn.faire.com/fastly/e29ea67ff828cc7ed5d8b65963c010711c791e691928f4e89c5d592b0a721ea8.jpeg",
    "https://cdn.faire.com/fastly/98a8c3588e18687fa69df5eb90bf7238bf7843b8f84871edd9f2e00a7588629b.jpeg",
    "https://cdn.faire.com/fastly/064a700974bb260897da8e82e96adc569be5f9446fe5adda4be0d763cbe5862c.jpeg",
    "https://cdn.faire.com/fastly/5bcc3a6d73fe1a62a6ee88032fe26e6b03b5010eaebb111fad04c1d3df1b4efc.jpeg",
    "https://cdn.faire.com/fastly/d1632455da6fd4061857d664139b7017fe05256a04e6972c0bc9e7bdc7948302.jpeg",
    "https://cdn.faire.com/fastly/3f66881b2fc44f21e4583ec6d947359eaa0f0ad3b5503d283746158fab7a25b0.jpeg",
    "https://cdn.faire.com/fastly/1c6d1869812be6985e411f8e556b9ffb46d174f0ff10a11df930ca9f41ffec3a.jpeg",
    "https://cdn.faire.com/fastly/729669dc538dacecd4a60e60d190c7dd37d5485997b8773e7ab7c9989304a369.jpeg",
    "https://cdn.faire.com/fastly/0d1f36974c6f1a8b86162abf25850c6b4f844edb2aaac164a1daee19a99640d8.jpeg",
    "https://cdn.faire.com/fastly/8205da15072fd6f5af930572d226eaf4577c6aff1cfd2e3a094bf85b82e66bdf.jpeg",
    "https://cdn.faire.com/fastly/d062f2a22f4f54172fdbe9d781c9069431a7f3aca78c9c65e2dbead85ec9f3aa.jpeg",
    "https://cdn.faire.com/fastly/d0856f0c3aa13ee0d1d9498714a82d87b4958c59a2808ca85f419737df11aecb.jpeg",
    "https://cdn.faire.com/fastly/d7db6ed69ab2b932e48f371e3f2cfa3e7dd1637070069b8fd0372c19e11a04ea.jpeg",
    "https://cdn.faire.com/fastly/b8188dda5687d53d3da8b5c988f80553b9df6546959f7843ad8afc504dd09aae.jpeg",
    "https://cdn.faire.com/fastly/3ba30ff7a3ed92250d924f60610755f6315459f7ffbf2831f583bf7ee29c1aa3.jpeg",
    "https://cdn.faire.com/fastly/2937fe1671a0a5d4edaa614119349ce1b6145c80c416539cfbf5ab7fa037d725.jpeg",
    "https://cdn.faire.com/fastly/ee9a722f87b419316854fa896909c936875f76827ece8d9448eb0024304ba239.jpeg",
    "https://cdn.faire.com/fastly/42f59d36b00a240ebc37aa68b1b632e03ec3fb5c0c78098a7ad195573f36295c.jpeg",
    "https://cdn.faire.com/fastly/fc1e1a8d161a331aa1c5583e1079546d5df2049630d9e6bbb7bcfef58160f482.jpeg",
    "https://cdn.faire.com/fastly/4cd4ba3c0d564dfefa8e66c65fb4640f0b1f82477966896a516fdabb0b1036fb.jpeg",
    "https://cdn.faire.com/fastly/39a7269a362ea0d105041621c290103d536c6360b3649a1481fb56d2d8d3133a.jpeg",
    "https://cdn.faire.com/fastly/4d7868274587ceb2659070c9dee2000e496ed769661313ea16748450874db220.jpeg",
    "https://cdn.faire.com/fastly/d8c532b12fc4f597c9db92368806291aab5f9d54e916fb8a615676f061726521.jpeg",
    "https://cdn.faire.com/fastly/c8b032436ea9d1164395e5e7588d6505162237171ed649d1bd784d43e9e6465d.jpeg",
    "https://cdn.faire.com/fastly/0cac0adfb532af3bce48ab3d4807e0066eb187af38106aae4422a7ab1a9b2068.jpeg",
    "https://cdn.faire.com/fastly/0c12b6107eba53e562743d0901ebd59af405f736dd884ff877db844a4774152d.jpeg",
    "https://cdn.faire.com/fastly/89514452e12d2fdd20f2388bbd9adc9bafc3851c8a154b2fe5e35c68b7a95074.jpeg",
    "https://cdn.faire.com/fastly/a56fafc625d77131306d2be6206b175eb4abcfe29d446b25b6c684169a39df6d.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "Long Curly Wavy Hair 16 Clip In Hair Extension For Women 6Pcs/Set High Temperature Fiber Ombre Fake Hairpiece\n\n20 Inch 6pcs clip in hair extensions, at weight about 230grams can full head looks more beautiful. 6pcs include: 1 piece of 7 inch wide 4 clip ins hair, 1 piece of 5 inch wide 3 clip ins hair, 2 pieces of 4 inch wide 2 clip ins hair, 2 pieces of 1.5 inch wide 1 clip ins hair.\n\nThe clip ins hair extension is made of High Quality Heat-Resisting Synthetic Fiber, it’s soft, washable and durable. Compared with other 4pcs clip on hair, We extra add 2 pieces 1 clips hair, You will have more choices to decide how to allocate clips to different areas according to your hair volume.",
  tags: [],
  msrpDollars: 24.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:08.844Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
